// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_AUTH } from "api/services/teacher/teacher.routes";

// Define a service using a base URL and expected endpoints
export const appUserApi = createApi({
  reducerPath: "appUserApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_AUTH
  }),

  endpoints: (builder) => ({
    checkEmail: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/users/email/check`,
          method: "POST",
          body,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useCheckEmailMutation } = appUserApi;
